module.exports = __webpack_public_path__ + "img/default-audio.4fce8f24.png";